module.exports = __webpack_public_path__ + "img/4.f7fbdbe0.jpg";